import { cloudBackend, request } from "./api";

function decode(value: string): ArrayBuffer {
  const base64 = value.replace(/-/g, "+").replace(/_/g, "/").padEnd(Math.ceil(value.length / 4) * 4, "=");
  const binary = atob(base64);
  return Uint8Array.from(binary, (char) => char.charCodeAt(0)).buffer;
}

function encode(value: ArrayBuffer): string {
  return btoa(String.fromCharCode(...new Uint8Array(value))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function credentialJSON(credential: PublicKeyCredential): Record<string, unknown> {
  const response = credential.response;
  const base = {
    id: credential.id,
    rawId: encode(credential.rawId),
    type: credential.type,
    clientExtensionResults: credential.getClientExtensionResults(),
  };
  if (response instanceof AuthenticatorAttestationResponse) {
    return { ...base, response: { clientDataJSON: encode(response.clientDataJSON), attestationObject: encode(response.attestationObject), transports: response.getTransports?.() || [] } };
  }
  const assertion = response as AuthenticatorAssertionResponse;
  return { ...base, response: { clientDataJSON: encode(assertion.clientDataJSON), authenticatorData: encode(assertion.authenticatorData), signature: encode(assertion.signature), userHandle: assertion.userHandle ? encode(assertion.userHandle) : null } };
}

export async function cloudSession(): Promise<boolean> {
  try {
    await request(cloudBackend(), "/api/v1/auth/session");
    return true;
  } catch {
    return false;
  }
}

export async function registerPasskey(bootstrapCode: string): Promise<void> {
  const backend = cloudBackend();
  const options = await request<Record<string, any>>(backend, "/api/v1/auth/register/options", {
    method: "POST",
    body: JSON.stringify({ bootstrap_code: bootstrapCode }),
  });
  options.challenge = decode(options.challenge);
  options.user.id = decode(options.user.id);
  options.excludeCredentials = (options.excludeCredentials || []).map((item: any) => ({ ...item, id: decode(item.id) }));
  const credential = await navigator.credentials.create({ publicKey: options as PublicKeyCredentialCreationOptions }) as PublicKeyCredential | null;
  if (!credential) throw new Error("Face ID registrace byla zrušena.");
  await request(backend, "/api/v1/auth/register/verify", {
    method: "POST",
    body: JSON.stringify({ bootstrap_code: bootstrapCode, credential: credentialJSON(credential) }),
  });
}

export async function loginPasskey(): Promise<void> {
  const backend = cloudBackend();
  const options = await request<Record<string, any>>(backend, "/api/v1/auth/login/options", { method: "POST", body: "{}" });
  options.challenge = decode(options.challenge);
  options.allowCredentials = (options.allowCredentials || []).map((item: any) => ({ ...item, id: decode(item.id) }));
  const credential = await navigator.credentials.get({ publicKey: options as PublicKeyCredentialRequestOptions }) as PublicKeyCredential | null;
  if (!credential) throw new Error("Face ID přihlášení bylo zrušeno.");
  await request(backend, "/api/v1/auth/login/verify", {
    method: "POST",
    body: JSON.stringify({ credential: credentialJSON(credential) }),
  });
}
